import $ from 'jquery';

export default function (mountpoint) {
	let triggers = $(mountpoint).find('ul.tab-triggers li');

	triggers.each(function() {
		const el = $(this);
		el.click(function(e) {
			e.preventDefault();
			activate(el);
		});
	});

	activate(triggers.first());

	function activate(triggerEl) {
		deactivateAll();
		const trigger = $(triggerEl);
		trigger.addClass('active');
		$(trigger.find('a').attr('href')).removeClass('tab-hidden');
	}

	function deactivateAll() {
		triggers.each(function() {
			const trigger = $(this);
			trigger.removeClass('active');
			$(trigger.find('> a').attr('href')).addClass('tab-hidden');
		});
	}
}
